export default "__VITE_ASSET__C$gNkkN3__"